import React, { useCallback } from 'react';
import { Anchor, xcss } from '@atlaskit/primitives';
import { proxyContextSafeUrl } from '@atlassian/jira-portfolio-3-common/src/api/index.tsx';
import { fireUIAnalytics, type UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import type { Props } from './types.tsx';

export default function IssueLink(props: Props) {
	const { projectKey, issueKey, issueId, xcssStyles, children, ariaLabel } = props;

	const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;
	const onClick = useCallback(
		(_: React.MouseEvent<HTMLAnchorElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'scopeIssueKey');
		},
		[],
	);

	return (
		<Anchor
			href={proxyContextSafeUrl(`/browse/${fullIssueKey}`)}
			rel="noopener noreferrer"
			id={issueId && `issue-link-${issueId}`}
			xcss={[anchorStyles, ...(xcssStyles ? [xcssStyles] : [])]}
			target="_blank"
			draggable={false}
			aria-label={ariaLabel}
			onClick={onClick}
		>
			{children || fullIssueKey}
		</Anchor>
	);
}

const anchorStyles = xcss({
	outlineOffset: 'space.0',
});
